(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(event) {
    const button = event.target.closest('[data-hero-buy-now]');
    if (!button) return;

    event.preventDefault();
    button.disabled = true;

    const variantId = button.dataset.variantId;
    const action = button.dataset.action || 'checkout';

    if (!variantId) {
      console.error('Buy Now button: No variant ID provided');
      button.disabled = false;
      return;
    }

    const rootPath = window.Shopify?.routes?.root || '/';

    try {
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionIds = [];
      cartItemsComponents.forEach(function(item) {
        if (item.dataset && item.dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });

      const payload = {
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      };

      if (sectionIds.length > 0) {
        payload.sections = sectionIds.join(',');
        payload.sections_url = window.location.pathname;
      }

      const response = await fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (result.status) {
        console.error('Buy Now error:', result.description);
        button.disabled = false;
        return;
      }

      if (action === 'checkout') {
        // Keep this theme-controlled shortcut inside the cart terms flow.
        window.location.href = rootPath + 'cart';
      } else {
        const cartUpdateEvent = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: result,
            sourceId: 'hero-buy-now',
            data: {
              source: 'hero-buy-now',
              itemCount: 1,
              variantId: variantId,
              sections: result.sections || {}
            }
          }
        });
        button.dispatchEvent(cartUpdateEvent);

        button.disabled = false;
      }
    } catch (error) {
      console.error('Buy Now fetch error:', error);
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
